import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import SynthwaveBackground from './components/common/SynthwaveBackground';
import AlphaDisclaimer from './components/common/AlphaDisclaimer';
import HomePage from './pages/HomePage';
import CoinDetailPage from './pages/CoinDetailPage';
import ExchangesPage from './pages/ExchangesPage';
import PortfolioPageV2 from './pages/PortfolioPageV2';
import TradFiPage from './pages/TradFiPage';

function App() {
  // Debug environment variables - FORCE REBUILD
  console.log('Environment:', process.env.REACT_APP_ENV);
  console.log('API URL:', process.env.REACT_APP_API_URL);
  console.log('Build timestamp:', new Date().toISOString());
  
  return (
    <Router>
      <div className="min-h-screen relative">
        <SynthwaveBackground />
        
        <div className="relative z-10 min-h-screen flex flex-col">
          <Header />
          <AlphaDisclaimer />
          
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<TradFiPage />} />
              <Route path="/crypto" element={<HomePage />} />
              <Route path="/coin/:coinId" element={<CoinDetailPage />} />
              <Route path="/exchanges" element={<ExchangesPage />} />
              <Route path="/tradfi" element={<TradFiPage />} />
              <Route path="/tradfi/:tab" element={<TradFiPage />} />
              <Route path="/portfolio" element={<PortfolioPageV2 />} />
            </Routes>
          </main>
          
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
